import {
  DataTypeKey,
  DataTypeKeys,
  DataTypes,
  DataTypeValues,
  getDataTypeGroup,
  generateTypeChecks,
  DataTypeConfig
} from '../../utils/data_types'
import {
  SubSessionTypeGroup,
  getSubSessionTypeGroup,
  subSessionTypesConfig
} from './sub_sessions/data_types'
export { subSessionTypes } from './sub_sessions/data_types'
export { sessionStateTypes } from './states/data_types'
export { sessionModeTypes } from './modes/data_types'

export type SessionTypeFeatures = {
  disableOption: boolean
  geniusAvailable: boolean
}

export const defaultSessionTypeFeatures: SessionTypeFeatures = {
  disableOption: false,
  geniusAvailable: false
}

export const sessionTypesConfig = {
  unknown: {
    key: 'unknown',
    name: 'Unknown',
    value: 'Unknown',
    props: {
      subTypes: getSubSessionTypeGroup({
        unknown: subSessionTypesConfig.unknown
      }),
      features: { ...defaultSessionTypeFeatures, disableOption: true }
    }
  },
  match: {
    key: 'match',
    name: 'Match',
    value: 'Match',
    props: {
      subTypes: getSubSessionTypeGroup({
        unknown: subSessionTypesConfig.unknown,
        dataGathering: subSessionTypesConfig.dataGathering,
        test: subSessionTypesConfig.test,
        broadcast: subSessionTypesConfig.broadcast
      }),
      features: {
        ...defaultSessionTypeFeatures,
        geniusAvailable: true
      }
    }
  },
  training: {
    key: 'training',
    name: 'Training',
    value: 'Training',
    props: {
      subTypes: getSubSessionTypeGroup({
        unknown: subSessionTypesConfig.unknown,
        dataGathering: subSessionTypesConfig.dataGathering,
        test: subSessionTypesConfig.test,
        teamPractice: subSessionTypesConfig.teamPractice
      }),
      features: {
        ...defaultSessionTypeFeatures
      }
    }
  }
} as const

export type SessionTypeProps = {
  subTypes: SubSessionTypeGroup
  features: SessionTypeFeatures
}

export type SessionTypes = DataTypes<typeof sessionTypesConfig>

export type SessionTypeKey = DataTypeKey<SessionTypes>

export type SessionTypeKeys = DataTypeKeys<SessionTypeKey>

export type SessionTypeValues = DataTypeValues<SessionTypeKey>

export const getSessionTypeGroup = (items: {
  [key in SessionTypeKeys]?: SessionTypes[key]
}) => {
  return getDataTypeGroup<
    SessionTypeKeys,
    SessionTypeValues,
    SessionTypes,
    SessionTypeProps
  >(items)
}

export type SessionTypeGroup = ReturnType<typeof getSessionTypeGroup>

export type SessionTypeConfig = DataTypeConfig<
  SessionTypeKeys,
  SessionTypeValues,
  SessionTypeProps
>

export const sessionTypes = getSessionTypeGroup(sessionTypesConfig)

export type SessionType = SessionTypeGroup['items'][SessionTypeKeys]

export const isSessionType = generateTypeChecks<
  SessionTypeKeys,
  SessionTypeGroup
>(sessionTypes)
